// @ts-nocheck
// 导入Vue
import Vue from 'vue';
// 导入路由
import VueRouter from 'vue-router';

// import store from '@/store/index.js';

// 导入 获取token的函数
// import { getToken } from "@/utils/token.js";        //, removeToken

// 按需导入 弹框
// import { Message } from "element-ui";
// import store from '../store'
// import { getPermitAccount} from '@/api/user.js'
// import { filterMenu } from '@/filters/index.js'

// // 导入 获取用户信息的接口
// import { info } from "@/api/login.js";

// // 导入 仓库
import store from '@/store/index.js';
// import { Message } from "element-ui";

// 注册
Vue.use(VueRouter);

// 创建路由对象
const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login'),
      hidden: true,
      meta: { noCache: true, title: '租售平台登陆系统' },
    },
    // 这个home路由位置别变,就让他排第2,因为在home/index中遍历
    {
      path: '/home',
      component: () => import('@/views/home/index'),
      name: 'home',
      redirect: '/home/chart',
      meta: {
        roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
      },
      children: [
        {
          path: 'chart',
          component: () => import('@/views/home/chart/index'),
          name: 'chart',
          meta: {
            noCache: true,
            title: '首页',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'examine',
          component: () => import('@/views/home/examine/index'),
          name: 'examine',
          meta: {
            noCache: true,
            title: '审批列表',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'reportStatistics',
          component: () => import('@/views/home/reportStatistics/index'),
          name: 'reportStatistics',
          redirect: '/home/reportStatistics/invitedReports',
          meta: {
            noCache: true,
            title: '统计报表',
            icon: 'el-icon-coin',
            roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
          },
          children: [
            {
              path: 'invitedReports',
              component: () =>
                import('@/views/home/reportStatistics/invitedReports/index'),
              name: 'invitedReports',
              meta: {
                noCache: true,
                title: '邀请报表',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
              hidden: true,
            },
            {
              path: 'recommendedReports',
              component: () =>
                import(
                  '@/views/home/reportStatistics/recommendedReports/index'
                ),
              name: 'recommendedReports',
              meta: {
                noCache: true,
                title: '推荐报表',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
              hidden: true,
            },
            {
              path: 'reportLoginLog',
              component: () =>
                import('@/views/home/reportStatistics/loginLog/index'),
              name: 'reportLoginLog',
              meta: {
                noCache: true,
                title: '登录日志',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'money',
          component: () => import('@/views/home/money/index'),
          name: 'money',
          redirect: '/home/money/userMoney',
          meta: {
            noCache: true,
            title: '佣金管理',
            icon: 'el-icon-coin',
            roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
          },
          children: [
            {
              path: 'userMoney',
              component: () => import('@/views/home/money/userMoney/index'),
              name: 'userMoney',
              meta: {
                noCache: true,
                title: '查看用户佣金',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
            },
            {
              path: 'lookAwait',
              component: () => import('@/views/home/money/lookAwait/index'),
              name: 'lookAwait',
              meta: {
                noCache: true,
                title: '查看待发放',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
              hidden: true,
            },
            {
              path: 'lookYet',
              component: () => import('@/views/home/money/lookYet/index'),
              name: 'lookYet',
              meta: {
                noCache: true,
                title: '查看已发放',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
              hidden: true,
            },
          ],
        },

        {
          path: 'hotelBanquet',
          component: () => import('@/views/home/hotel/index'),
          name: 'hotelBanquet',
          meta: {
            noCache: true,
            title: '报表管理',
            icon: 'el-icon-coin',
            roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
          },
          children: [
            {
              path: 'hotelBanquetRecommend',
              component: () =>
                import('@/views/home/hotel/recommendedReports/index'),
              name: 'hotelBanquetRecommend',
              meta: {
                noCache: true,
                title: '推荐报表',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'hotelBanquetLogin',
              component: () => import('@/views/home/hotel/loginLog/index'),
              name: 'hotelBanquetLogin',
              meta: {
                noCache: true,
                title: '登录日志',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'log',
          component: () => import('@/views/home/log/index'),
          name: 'log',
          redirect: '/home/log/loginLog',
          meta: {
            noCache: true,
            title: '日志管理',
            icon: 'el-icon-coin',
            roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
          },
          children: [
            {
              path: 'loginLog',
              component: () => import('@/views/home/log/loginLog/index'),
              name: 'loginLog',
              meta: {
                noCache: true,
                title: '登录日志',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
            },
            {
              path: 'eventLog',
              component: () => import('@/views/home/log/eventLog/index'),
              name: 'eventLog',
              meta: {
                noCache: true,
                title: '操作日志',
                roles: ['系统角色', '中介经济人', '普通员工', '内部员工'],
              },
              hidden: true,
            },
          ],
        },
        {
          path: 'visit',
          component: () => import('@/views/home/visit/index'),
          name: 'visit',
          meta: {
            noCache: true,
            title: '客户管理',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'news',
          component: () => import('@/views/home/news/index'),
          name: 'news',
          meta: {
            noCache: true,
            title: '新闻管理',
            icon: 'el-icon-monitor',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'propertyRecommendation',
          component: () => import('@/views/home/recommendedReport/index'),
          name: 'propertyRecommendation',
          meta: {
            noCache: true,
            title: '物业服务-物业推荐报表',
            icon: 'el-icon-monitor',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'referrerInfor',
          component: () => import('@/views/home/referrerInfor/index'),
          name: 'referrerInfor',
          meta: {
            noCache: true,
            title: '推荐人信息一览表',
            icon: 'el-icon-monitor',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'user',
          redirect: '/home/user/visit',
          component: () => import('@/views/home/user/index'),
          name: 'user',
          meta: {
            noCache: true,
            title: '用户管理',
            icon: 'el-icon-user-solid',
            roles: ['系统角色'],
          },
          children: [
            // {
            //     path: 'visit',
            //     component: () =>
            //         import ('@/views/home/user/visit/index'),
            //     name: 'Visit',
            //     meta: { noCache: true, title: '到访管理', roles: ['系统角色', '内部员工'] }
            // },
            {
              path: 'visit',
              component: () => import('@/views/home/visit/index'),
              name: 'visit',
              meta: {
                noCache: true,
                title: '客户管理',
                icon: 'el-icon-s-home',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'authority',
              component: () => import('@/views/home/user/authority/index'),
              name: 'authority',
              meta: { noCache: true, title: '账号管理', roles: ['系统角色'] },
            },
            {
              path: 'role',
              component: () => import('@/views/home/user/roleList/index'),
              name: 'role',
              meta: { noCache: true, title: '角色管理', roles: ['系统角色'] },
            },
            {
              path: 'menu',
              component: () => import('@/views/home/user/menuList/index'),
              name: 'menu',
              meta: { noCache: true, title: '菜单管理', roles: ['系统角色'] },
            },
            {
              path: 'sm',
              component: () => import('@/views/home/user/sm/index'),
              name: 'sm',
              meta: {
                noCache: true,
                title: '系统权限管理',
                roles: ['系统角色'],
              },
            },
            {
              path: 'functionList',
              component: () => import('@/views/home/user/functionList/index'),
              name: 'functionList',
              meta: { noCache: true, title: '功能列表', roles: ['系统角色'] },
            },
            {
              path: 'agent',
              component: () => import('@/views/home/user/agent/index'),
              name: 'agent',
              meta: {
                noCache: true,
                title: '经纪人管理',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'city',
          component: () => import('@/views/home/city/index'),
          name: 'city',
          meta: {
            noCache: true,
            title: '城市管理',
            icon: 'el-icon-office-building',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'appPublish',
          component: () => import('@/views/home/appPublish/index'),
          name: 'appPublish',
          meta: {
            noCache: true,
            title: 'app版本管理',
            icon: 'el-icon-office-building',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'ubanner',
          redirect: '/home/ubanner/position',
          component: () => import('@/views/home/ubanner/index'),
          name: 'bannerName',
          meta: {
            noCache: true,
            title: '广告管理',
            icon: 'el-icon-user-solid',
            roles: ['系统角色'],
          },
          children: [
            {
              path: 'position',
              name: 'position',
              component: () => import('@/views/home/ubanner/position/index'),
              meta: {
                noCache: true,
                title: '广告位管理',
                icon: 'el-icon-s-order',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'banner',
              component: () => import('@/views/home/ubanner/banner/index'),
              name: 'banner',
              meta: {
                noCache: true,
                title: '广告管理',
                icon: 'el-icon-location',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'service',
          redirect: '/home/service/chat',
          component: () => import('@/views/home/service/index'),
          name: 'service',
          meta: {
            noCache: true,
            title: '客服管理',
            icon: 'el-icon-user-solid',
            roles: ['系统角色'],
          },
          children: [
            {
              path: 'chat',
              name: 'chat',
              component: () => import('@/views/home/service/chat/index'),
              meta: {
                noCache: true,
                title: '聊天室',
                icon: 'el-icon-s-order',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'talk',
              name: 'chat',
              component: () => import('@/views/home/service/chat/chat'),
              meta: {
                noCache: true,
                title: '聊天室',
                icon: 'el-icon-s-order',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'allot',
              component: () => import('@/views/home/service/allot/index'),
              name: 'allot',
              meta: {
                noCache: true,
                title: '客服分配',
                icon: 'el-icon-location',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'robot',
              component: () => import('@/views/home/service/robot/index'),
              name: 'robot',
              meta: {
                noCache: true,
                title: '智能回复',
                icon: 'el-icon-location',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'houseAdmin',
          redirect: '/home/houseAdmin/house',
          component: () => import('@/views/home/houseAdmin/index'),
          name: 'houseAdmin',
          meta: {
            noCache: true,
            title: '楼盘管理',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
          children: [
            {
              path: 'house',
              name: 'house',
              component: () => import('@/views/home/houseAdmin/house/index'),
              meta: {
                noCache: true,
                title: '楼盘管理',
                icon: 'el-icon-s-home',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'houseNews',
              name: 'houseNews',
              component: () =>
                import('@/views/home/houseAdmin/houseNews/index'),
              meta: {
                noCache: true,
                title: '楼盘动态管理',
                icon: 'el-icon-monitor',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'message',
          redirect: '/home/message/my-msg',
          component: () => import('@/views/home/message/index'),
          name: 'message',
          meta: {
            noCache: true,
            title: '消息管理',
            icon: 'el-icon-user-solid',
            roles: ['系统角色'],
          },
          children: [
            {
              path: 'my-msg',
              name: 'my-msg',
              component: () => import('@/views/home/message/my-msg/index'),
              meta: {
                noCache: true,
                title: '我的消息',
                icon: 'el-icon-s-order',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'admin-msg',
              component: () => import('@/views/home/message/admin-msg/index'),
              name: 'admin-msg',
              meta: {
                noCache: true,
                title: '系统消息',
                icon: 'el-icon-location',
                roles: ['系统角色', '内部员工'],
              },
            },
          ],
        },
        {
          path: 'feedBack',
          component: () => import('@/views/home/feedBack/index'),
          name: 'feedBack',
          meta: {
            noCache: true,
            title: '用户反馈',
            icon: 'el-icon-office-building',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'live',
          redirect: '/home/live/livePreview',
          component: () => import('@/views/home/live/index'),
          name: 'live',
          meta: {
            noCache: true,
            title: '直播管理',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
          children: [
            {
              path: 'livePreview',
              name: 'livePreview',
              component: () => import('@/views/home/live/livePreview/index'),
              meta: {
                noCache: true,
                title: '直播预告管理',
                icon: 'el-icon-s-home',
                roles: ['系统角色', '内部员工'],
              },
            },
            {
              path: 'liveNews',
              name: 'liveNews',
              component: () => import('@/views/home/live/liveNews/index'),
              meta: {
                noCache: true,
                title: '直播动态管理',
                icon: 'el-icon-monitor',
                roles: ['系统角色', '内部员工'],
              },
              hidden: true,
            },
            {
              path: 'anchor',
              component: () => import('@/views/home/live/anchor/index'),
              name: 'anchor',
              meta: { noCache: true, title: '主播管理', roles: ['系统角色'] },
            },
          ],
        },
        {
          path: 'help',
          component: () => import('@/views/home/help/index'),
          name: 'help',
          meta: {
            noCache: true,
            title: '帮助中心',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'privacyPolicy',
          component: () => import('@/views/home/privacyPolicy/index'),
          name: 'privacyPolicy',
          meta: {
            noCache: true,
            title: '隐私条例管理',
            icon: 'el-icon-s-home',
            roles: ['系统角色', '内部员工'],
          },
        },
        {
          path: 'permission',
          redirect: '/home/permission/role',
          component: () => import('@/views/home/permission/index'),
          name: 'permission',
          meta: {
            noCache: true,
            title: '权限管理',
            icon: 'el-icon-user-solid',
            roles: ['系统角色'],
          },
          children: [
            {
              path: 'internalAccount',
              component: () =>
                import('@/views/home/permission/internalAccount/index'),
              name: 'internalAccount',
              meta: { noCache: true, title: '内部账号', roles: ['系统角色'] },
            },
            {
              path: 'externalAccount',
              component: () =>
                import('@/views/home/permission/externalAccount/index'),
              name: 'externalAccount',
              meta: { noCache: true, title: '外部账号', roles: ['系统角色'] },
            },
            {
              path: 'role',
              component: () => import('@/views/home/permission/roleList/index'),
              name: 'role',
              meta: { noCache: true, title: '角色管理', roles: ['系统角色'] },
            },
            {
              path: 'menu',
              component: () => import('@/views/home/permission/menuList/index'),
              name: 'menu',
              meta: { noCache: true, title: '菜单管理', roles: ['系统角色'] },
            },
            {
              path: 'sm',
              component: () => import('@/views/home/permission/sm/index'),
              name: 'sm',
              meta: {
                noCache: true,
                title: '系统权限管理',
                roles: ['系统角色'],
              },
            },
            {
              path: 'functionList',
              component: () =>
                import('@/views/home/permission/functionList/index'),
              name: 'functionList',
              meta: { noCache: true, title: '功能列表', roles: ['系统角色'] },
            },
            {
              path: 'sm',
              component: () => import('@/views/home/permission/sm/index'),
              name: 'sm',
              meta: {
                noCache: true,
                title: '推荐报表',
                roles: ['系统角色'],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/choose',
      name: 'Choose',
      component: () => import('@/views/choose'),
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import('@/views/privacyPolicy'),
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: () => import('@/views/serviceAgreement'),
    },
    {
      path: '/jumpToApp',
      name: 'jumpToApp',
      component: () => import('@/views/jumpToApp'),
    },
    {
      path: '/404',
      component: () => import('@/views/error-page/404.vue'),
      hidden: true,
    },
    {
      path: 'house-pic',
      component: () => import('@/views/home/house-pic/index'),
      name: 'house-pic',
      meta: { noCache: true, title: '楼盘图片', icon: 'el-icon-picture' },
      hidden: true,
    },
    {
      path: '/401',
      component: () => import('@/views/error-page/401.vue'),
      hidden: true,
    },
    { path: '*', redirect: '/404', hidden: true },
  ],
});
router.beforeEach((to, from, next) => {
  // console.log('进入路由：');
  let obj = {
    pageSize: 20,
    pageIndex: 1,
  };
  store.dispatch('area/setPaginObj', obj);
  next();
});
// 解决双击home页面侧边栏点击多次跳转路由的报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location);
};

export default router;
